import { Store } from '@tanstack/store';

type ChatState = {
  chatName: string | null;
  chatId: string;
  lastAssistantMessageId: string | null;
};

export const InitialChatStore: ChatState = {
  chatName: null,
  chatId: '',
  lastAssistantMessageId: null,
};

export const ChatStore = new Store<ChatState>(InitialChatStore);
